import React from "react";
import { ui } from "../../../../../../../interfaces/interfaces";
import CarePlanDetails from "./Plan";
import CareCustomerDetails from "./Customer";
import CarePaymentDetails from './Payment';
import CareBillingDetails from "./Billing";
import useDebugInformation from '../../../../../../../hooks/useDebugInformation';
import TabPanel from "../../../../../../Shared/StepThreeTabPanel"
import PlanHeader from "./Header";
import CarePlanTabHeader from '../../../../../../Shared/CarePlanTabHeader';
import Box from "@mui/material/Box";
import { carePlanValidate } from "@utils/general";
import { useAppSelector } from "@store/hooks";
import { useGetAvailabilityForCurrentJobAddress } from "../../../../../../../hooks/useCheckAval";
import useGetAvailableOffers from "../../../../../../../hooks/useGetAvailableOffers";
import useRecalculatePayments from "../../../../../../../hooks/useRecalculatePayments";
import SwipeableViews from "@arzymski/react-swipeable-views";

const name = "CarePlanTab"

const handleChangeIndex = (index: number) => {
  ui.CarePlanActiveTab = index
};

type Props = {
  parent: string
}

const CarePlanTab: React.FC<Props> = ({ parent }) => {
  const serviceAgreementTabsList = useAppSelector(({ ui }) => ui.CarePlanTabsList)
  const serviceAgreementActiveTab = useAppSelector(({ ui }) => ui.CarePlanActiveTab)
  const serviceAgreementDeclinedReason = useAppSelector(({ ui }) => ui.CarePlanDeclinedReason)
  const serviceAgreementOffered = useAppSelector(({ ui }) => ui.CarePlanOffered)

  React.useEffect(() => {
    carePlanValidate();
  }, [serviceAgreementOffered, serviceAgreementDeclinedReason])


  const debugName = `${parent}▷[${name}]`
  useRecalculatePayments()
  useGetAvailableOffers()
  useGetAvailabilityForCurrentJobAddress()

  useDebugInformation(debugName, { serviceAgreementTabsList, serviceAgreementActiveTab, serviceAgreementDeclinedReason, serviceAgreementOffered })
  return (
    <Box sx={(theme) => ({
      backgroundColor: theme.palette.background.paper,
      width: "100%",
      position: "relative",
      minHeight: 160,
      '& .react-swipeable-view-container > div': { overflow: "hidden !important" }
    })}>
      <PlanHeader />
      {serviceAgreementOffered && !serviceAgreementDeclinedReason?.serviceAgreementDeclinedId && (
        <>
          <CarePlanTabHeader parent={debugName} affix="ServiceAgreement" />
          <SwipeableViews axis="x" index={serviceAgreementActiveTab} onChangeIndex={handleChangeIndex}>
            <TabPanel parent={debugName} value={serviceAgreementActiveTab} index={0}>
              <CarePlanDetails parent={debugName} />
            </TabPanel>
            <TabPanel parent={debugName} value={serviceAgreementActiveTab} index={1} >
              <CareCustomerDetails parent={debugName} />
            </TabPanel>
            <TabPanel parent={debugName} value={serviceAgreementActiveTab} index={2} >
              <CareBillingDetails parent={debugName} />
            </TabPanel>
            <TabPanel parent={debugName} value={serviceAgreementActiveTab} index={3}>
              <CarePaymentDetails parent={debugName} />
            </TabPanel>
          </SwipeableViews>
        </>)}
    </Box >)
}

export default CarePlanTab